import Cookies from "js-cookie";
import api from "../../config/base";

import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  REGISTER_FAIL,
  LOGOUT_SUCCESS,
} from "./types";

export const login = ({ email, password }) => async (dispatch) => {
  try {
    const res = await api.post(`Auth/login`, { email, password });
    //console.log(res.data)
    if (res.status === 200) {
      console.log('response',res.data)
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: LOGIN_FAIL,
        payload: res.message,
      });
    }
  } catch (error) {
    dispatch({
      type: LOGIN_FAIL,
      payload: error.message,
    });
  }
};

export const register = (username, email, password, role) => async (
  dispatch
) => {
  try {
    await api.post(`register`, { username, email, password, role });
  } catch (error) {
    dispatch({
      type: REGISTER_FAIL,
      payload: error.message,
    });
  }
};

export const logout = () => async (dispatch) => {
  const res = await Cookies.remove("jwt");
  dispatch({
    type: LOGOUT_SUCCESS,
    payload: res,
  });
};